import { GridProps } from './types'

export const Col = ({ col = '12', children, ...rest }: GridProps) => (
  <div className={`col-${Number(col)}`} {...rest}>
    {children}
  </div>
)

export const Row = ({ children, ...rest }: GridProps) => (
  <div className="row" {...rest}>
    {children}
  </div>
)

export const Container = ({ children, ...rest }: GridProps) => (
  <div className="container" {...rest}>
    {children}
  </div>
)
